(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hitoki-halloween-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hitoki-halloween-notice')) {
  customElements.define('hitoki-halloween-notice', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.onVariant = (event) => {
        const variant = event.detail && event.detail.variant;
        this.hidden = Date.now() >= Date.parse(this.dataset.end) || !variant ||
          !variant.available || !this.dataset.eligibleIds.split(',').includes(String(variant.id));
      };
      this.form?.addEventListener('variant:change', this.onVariant);
      const remaining = Date.parse(this.dataset.end) - Date.now();
      if (remaining <= 0) this.hidden = true;
      else this.expiryTimer = setTimeout(() => { this.hidden = true; }, remaining);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.onVariant);
      clearTimeout(this.expiryTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
